import { useEffect, useState } from 'react';
import { db, auth } from '../firebase/config';
import { doc, getDoc } from 'firebase/firestore';

let cachedLogo       = undefined; // undefined = not fetched; null = fetched, no logo; string = url
let cachedCompanyLogo = undefined;
let cachedAltLogo    = undefined;

function useCompanyField(field, cache, setCache) {
  const [logoUrl, setLogoUrl] = useState(typeof cache === 'string' ? cache : null);

  useEffect(() => {
    if (typeof cache === 'string') return;

    const uid = auth.currentUser?.uid;
    if (!uid) return;

    getDoc(doc(db, 'users', uid))
      .then(userSnap => {
        const companyId = userSnap.data()?.companyId;
        if (!companyId) return null;
        return getDoc(doc(db, 'companies', companyId));
      })
      .then(compSnap => {
        if (!compSnap) return;
        const url = compSnap.exists() ? (compSnap.data()[field] || null) : null;
        setCache(url || undefined);
        if (url) setLogoUrl(url);
      })
      .catch(() => {});
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return logoUrl;
}

export function useQRLogo() {
  return useCompanyField('qrLogoUrl', cachedLogo, v => { cachedLogo = v; });
}

// Company logo (logo field) — used on print sheets etc.
export function useCompanyLogo() {
  return useCompanyField('logo', cachedCompanyLogo, v => { cachedCompanyLogo = v; });
}

// Alternativ logotyp (används i PitchN-presentationer)
export function useAltLogo() {
  return useCompanyField('altLogo', cachedAltLogo, v => { cachedAltLogo = v; });
}

// Call these after uploading a new logo so the cache is cleared
export function invalidateQRLogoCache() {
  cachedLogo = undefined;
}
export function invalidateCompanyLogoCache() {
  cachedCompanyLogo = undefined;
}
export function invalidateAltLogoCache() {
  cachedAltLogo = undefined;
}
